
window._ = require('lodash');
window.Popper = require('popper.js').default;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');

} catch (e) {}

window.Swal = require('sweetalert2');

window.axios = require('axios');

window.axios.defaults.baseURL = `${process.env.VUE_APP_BACKEND_URL}/api`;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
